import React, { useState, useEffect, useRef } from "react";
import Head from "next/head";
import { useMediaQuery } from "react-responsive";
import Router from "next/router";
import dynamic from "next/dynamic";
import RegistrationHeader from "./SubComponents/RegistrationHeader";
import PickTickets from "./SubComponents/PickTickets/PickTickets";
import WidgetContext from "./../../../contexts/WidgetContext";
import {
	addTeamDetailsToCapture,
	checkIfExpired,
	convertToFormikValues,
	errorToaster,
	getCurrencyId,
	getPaymentType,
	paymentErrorHelper
} from "./../../../helpers/utils";
import CartBox from "./SubComponents/CartBox/Cartbox";
import { baseUrl } from "../../../config/config";
import RegistrationTimer from "./SubComponents/RegistrationTimer";
import { useRouter } from "next/router";
import { leadsApi } from "../../../crud/checkout.crud";
import { filterObjectsById, getGroupDiscountDetails } from "../../../helpers/common";
import moment from "moment";
import TicketExpired from "./SubComponents/TicketExpired";
import Modal from "react-modal";
import Loading from "../../../components/Loading";
import _ from "lodash";

const PaymentErrorModal = dynamic(() => import("../../../components/Modal/PaymentErrorModal"));
const AttendeeDetails = dynamic(() => import("./SubComponents/AttendeeDetails/AttendeeDetails"));
const ReviewTickets = dynamic(() => import("./SubComponents/ReviewTickets/ReviewTickets"));
const TeamBasedComponent = dynamic(
	() => import("../../DedicatedEventPage/GeneralComponents/TeamBased/TeamBasedComponent")
);

const modalStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-40%",
		transform: "translate(-50%, -50%)",
		minwidth: "320px",
		maxWidth: "720px",
		minheight: "32px",
		maxheight: "80vh"
	}
};

const RegistrationBox = ({
	eventDetails,
	ticketDetails,
	groupDiscounts,
	totalActiveRegs,
	query,
	isWidget,
	isLoading,
	waitlistDetails,
	setWaitlistDetails,
	widgetType,
	setTicketDetails,
	setTicketExpired,
	curComp,
	setCurComp,
	isBackClicked,
	setIsBackClicked,
	setSelectedTickets,
	getTicketDetails,
	handleBackBtn,
	openPaymentModal,
	setOpenPaymentModal,
	teamRegStatus,
	teamRegType,
	setTeamRegType,
	formRules,
	setFormRules,
	setTeamRegStatus,
	isEventPageTeamComp,
	setIsEventPageTeamComp
}) => {
	const router = useRouter();
	const [pickedTickets, setPickedTickets] = useState([]); // (Gets tickets selected by user from picktickets component)
	const [attendeesDetails, setAttendeesDetails] = useState([]); // (Gets attendee details in the form needed to be passed to post call)
	const [isCheckoutSubmitted, setIsCheckoutSubmitted] = useState(false);
	const [formikValues, setFormikValue] = useState(""); //
	const [reviewDetails, setReviewDetails] = useState([]); //Get data in a form where it can be used inside reviewTickets Component
	const [initialMount, setInitialMount] = useState(true); //this is for ticketId query used in pickticket.js, it should only run on mount.
	const [otp, setOtp] = useState("");

	const [couponCode, setCouponCode] = useState("");
	const [couponErr, setCouponErr] = useState("");
	const [couponCodeLimit, setCouponCodeLimit] = useState(null);
	const [couponInitialLimit, setCouponInitialLimit] = useState(null);
	const [isNewCode, setIsNewCode] = useState(false);
	const [accessCodeStatus, setAccessCodeStatus] = useState(0); // 0 -> is no access code applies, 1 -> is access code applied, 2 -> access code just removed
	const [isValidating, setIsValidating] = useState(false); //This is for attendee details page & the cart button component - do disable button on validation

	const [orderAmount, setOrderAmount] = useState(0);
	const [utm, setUtm] = useState(0);

	const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
	const [leadsResponse, setLeadsResponse] = useState([]);
	const [isApproval, setIsApproval] = useState(false);
	const [gstDetails, setGstDetails] = useState({});
	const [couponLoading, setCouponLoading] = useState(false);
	const accessCodeTriggered = useRef(false);
	const triggeredOnce = useRef(false); //To use in pickticket.js, to run a condition only once (on initial load)

	const isInternationalEvent = eventDetails.currency_name !== "INR" ? true : false;
	const isInternationalTicket =
		!_.isEmpty(pickedTickets) &&
			pickedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
			? true
			: false; //domestic event where international ticket is selected

	const [paymentMethod, setPaymentMethod] = useState("");

	const isWaitlist = waitlistDetails ? true : false; //is coming for waitlist / approval payment

	const [profileData, setProfileData] = useState(false); // prefill profile data
	//For payment error modal
	const [openErrModal, setOpenErrModal] = useState(false);
	const [modalErrType, setModalErrType] = useState(1);

	const [emailApiErrors, setEmailApiErrors] = useState({});
	const [textInputErrors, setTextInputErrors] = useState(false);
	const [textInputErrorMsg, setTextInputErrorMsg] = useState({});

	const handleMediaQueryChange = matches => {
		smallerScreen = matches;
		// matches will be true or false based on the value for the media query
	};
	//coupon box margin bottom
	const [marginBottom, setMarginBottom] = useState("0px");

	useEffect(() => {
		// Check if eventDetails?.checkout_footer_icon exists and set the margin accordingly
		setMarginBottom(eventDetails?.checkout_footer_icon ? "0px" : "100px");
	}, [eventDetails?.checkout_footer_icon]);

	let smallerScreen = useMediaQuery({ maxWidth: 768 }, undefined, handleMediaQueryChange);
	const faviconIconUrl = eventDetails.fav_icon_urls && eventDetails.fav_icon_urls["favicon.ico"];

	const onTicketSelect = tickets => {
		// on press of proceed button in pickTicket
		setPickedTickets(tickets);
	};

	const onProceed = (tickets, isApproval = false) => {
		// on press of proceed button from pickTicket
		if (teamRegType === 1) {
			//If team based ticket check if it is more than minimum team tickets
			let totalRegistrations = 0;
			for (const ticket of tickets) {
				totalRegistrations += ticket.totalSelected;
			}
			if (totalRegistrations < eventDetails.min_team_members) {
				errorToaster(
					`You have to add minimum ${eventDetails.min_team_members} tickets to proceed.`
				);
				return;
			}
		} else if (isApproval) setIsApproval(true);
		setIsNewCode(true);
		setPickedTickets(tickets);
		setCurComp(curComp + 1);
		setSelectedTickets(tickets);
	};

	const makeLeadsCall = async (attendeesDetails, checkoutData, GSTDetails) => {
		// setLeadsApiLoading(true);
		setIsCheckoutLoading(true);
		const eventId = eventDetails.event_id;
		const cur = pickedTickets.find(obj => obj.currency_name !== eventDetails.currency_name)
			? pickedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name)
				.currency_name
			: eventDetails.currency_name;
		const currencyId = getCurrencyId(cur);
		const groupDiscountCode = getGroupDiscountDetails(
			groupDiscounts,
			pickedTickets,
			couponCode
		).maxDiscountCode;
		const data = {
			...GSTDetails,
			...(groupDiscountCode && { group_discount_code: groupDiscountCode }),
			...(couponCode && { coupon_code: couponCode }),
			...(query.booking_id && { booking_id: query.booking_id }),
			...(utm && { utm: utm }),
			...(groupDiscountCode && couponCode ? { primary_discount_type: 2 } : {}),
			order_amount: orderAmount, //Need in Paisa format
			currency_id: parseInt(currencyId),
			registration_details: attendeesDetails,
			registration_tz: eventDetails.time_zone,
			...addTeamDetailsToCapture(teamRegType)
		};

		try {
			const res = await leadsApi(eventId, data);
			setIsCheckoutLoading(false);
			if (res.data.hasOwnProperty("pg_config")) {
				if (res.data.pg_config.length == 1)
					setPaymentMethod(getPaymentType(res.data.pg_config[0].pg_type, "pg_type_name")); // when its only one payment method default it to that payment method
			}
			setLeadsResponse(res.data);
			if (orderAmount === 0) addBookingIdToAttendeesDetails(res.data, checkoutData);
			setCurComp(curComp + 1);
		} catch (err) {
			const errMessage = err.response.data;
			if (errMessage.error.error_code) setModalErrType(errMessage.error.error_code);
			else setModalErrType(paymentErrorHelper(errMessage.error));
			setOpenErrModal(true);
			setIsCheckoutLoading(false);
			console.log(err);
		}
	};

	const onCheckout = async (data, reviewDetails, formikValue, GSTDetails) => {
		if (GSTDetails) setGstDetails({ ...GSTDetails });

		const checkoutData = JSON.parse(JSON.stringify(data));
		const leadsData = JSON.parse(JSON.stringify(data));

		for (const ticketId of Object.keys(checkoutData)) {
			for (const index of checkoutData[ticketId].keys()) {
				const customForms = checkoutData[ticketId][index]?.custom_forms || [];
				for (const key of Object.keys(customForms)) {
					if (customForms[key] === "undefined" || customForms[key] === null) {
						customForms[key] = null;
					}
				}
				if (
					checkoutData[ticketId][index].allow_single_buyer &&
					!checkoutData[ticketId][index].free_ticket
				) {
					delete checkoutData[ticketId][index].allow_single_buyer;
					delete checkoutData[ticketId][index].free_ticket;
				} else {
					delete checkoutData[ticketId][index].allow_single_buyer;
					delete checkoutData[ticketId][index].free_ticket;
				}
			}
		}

		for (const ticketId of Object.keys(leadsData)) {
			for (const index of leadsData[ticketId].keys()) {
				const customForms = leadsData[ticketId][index]?.custom_forms || [];
				for (const key of Object.keys(customForms)) {
					if (customForms[key] === undefined || customForms[key] === null) {
						customForms[key] = "";
					}
				}
				if (
					leadsData[ticketId][index].allow_single_buyer &&
					leadsData[ticketId][index].free_ticket
				) {
					delete leadsData[ticketId][index].quantity;
					delete leadsData[ticketId][index].allow_single_buyer;
					delete leadsData[ticketId][index].free_ticket;
				} else {
					delete leadsData[ticketId][index].allow_single_buyer;
					delete leadsData[ticketId][index].free_ticket;
				}
			}
		}

		setAttendeesDetails(checkoutData);
		setReviewDetails(reviewDetails);
		setFormikValue({ ...GSTDetails, ...formikValue });

		await makeLeadsCall(leadsData, checkoutData, GSTDetails);
	};

	useEffect(() => {
		// This is run when user goes to pick ticket component
		if (curComp === 0 && isBackClicked) {
			let discountTickets = 0;
			let isCouponApplicable = false;
			pickedTickets.forEach(ticket => {
				if (ticket.hasOwnProperty("discount")) {
					discountTickets = discountTickets + ticket.totalSelected;
					if (ticket.coupon_applicable) isCouponApplicable = true;
				}
			});
			if (otp) setOtp("");
			if (isApproval) setIsApproval(false);
			if (isCouponApplicable) setCouponCodeLimit(couponInitialLimit);
			setProfileData(false); // back clicked to pick tickets, prefill data will be set to false
			setIsBackClicked(false);
		} else if (curComp < 2 && paymentMethod)
			setPaymentMethod(""); //remove any payment method selected
		else if (curComp === 3 && !_.isEmpty(pickedTickets)) setPickedTickets([]); //Empty picked / selected tickets if user comes to team page after coming back
	}, [curComp, isBackClicked]);

	useEffect(() => {
		if (curComp === 1 && pickedTickets.length === 1) {
			checkIfExpired(pickedTickets, eventDetails, setTicketExpired);
		}
	}, [curComp]);

	// const onBackBtn = (component) => {
	//   if (component === "Attendees") {
	//     let discountTickets = 0;
	//     let isCouponApplicable = false;
	//     pickedTickets.forEach((ticket) => {
	//       if (ticket.discount) {
	//         discountTickets = discountTickets + ticket.totalSelected;
	//         if (ticket.coupon_applicable) isCouponApplicable = true;
	//       }
	//     });
	//     setCurComp(0);
	//     if (isCouponApplicable) setCouponCodeLimit(couponInitialLimit)
	//   } else if (component === "Review") {
	//     setCurComp(1);
	//   }
	// }

	const getCouponDetails = (couponDetails = false, coupon, accessCodeTicket = false) => {
		// setTicketDetails
		let newTicketDetails = [];

		if (accessCodeTicket.length > 0) newTicketDetails = [...accessCodeTicket];
		else if (isWaitlist) newTicketDetails = [waitlistDetails[0]];
		//if added coupon code while waitlist / approval payment
		else newTicketDetails = [...ticketDetails];

		const couponTickets = couponDetails.applicable_tickets;
		let notTeamBasedHiddenTicket = false;
		let isTeamBasedHiddenTicket = false;
		newTicketDetails.forEach(ticket => {
			const ticketPrice = ticket.ticket_price - (ticket?.group_discount_price || 0);
			ticket.final_price = ticketPrice;
			ticket.discount_remaining = null;
			ticket.coupon_applicable = null;
			ticket.discounted_price = null;

			let finalPrice;
			//If coupon code and not access code
			if (couponDetails && !accessCodeTicket) {
				ticket.discount = null;
				if (couponTickets.includes(ticket.ticket_id)) {
					ticket.coupon_applicable = true;
					ticket.discount = couponDetails.discount;
					if (couponDetails.discount_type === 1) {
						finalPrice = ticketPrice - ticket.discount;
						ticket.discounted_price = ticket.discount;
						ticket.final_price =
							finalPrice.toFixed(2) % 1 != 0 ? finalPrice.toFixed(2) : finalPrice;
					} else if (couponDetails.discount_type === 2) {
						finalPrice = ticketPrice - (ticket.discount / 100) * ticketPrice;
						ticket.discounted_price = (ticket.discount / 100) * ticketPrice;
						ticket.final_price =
							finalPrice.toFixed(2) % 1 != 0 ? finalPrice.toFixed(2) : finalPrice;
					}
					if (finalPrice <= 0) {
						ticket.final_price = 0;
					}
				}
			} else {
				// If access code
				ticket.coupon_applicable = true;
				if (ticket.discount_type === 1) {
					finalPrice = ticketPrice - ticket.discount;
					ticket.discounted_price = ticket.discount;
					ticket.final_price =
						finalPrice.toFixed(2) % 1 != 0 ? finalPrice.toFixed(2) : finalPrice;
				} else if (ticket.discount_type === 2) {
					finalPrice = ticketPrice - (ticket.discount / 100) * ticketPrice;
					ticket.discounted_price = (ticket.discount / 100) * ticketPrice;
					ticket.final_price =
						finalPrice.toFixed(2) % 1 != 0 ? finalPrice.toFixed(2) : finalPrice;
				}
				if (finalPrice <= 0) {
					ticket.final_price = 0;
				}
				if (!ticket.team_registration) {
					notTeamBasedHiddenTicket = true;
				}
				if (ticket.team_registration) {
					isTeamBasedHiddenTicket = true;
				}
			}
		});
		// if coupon code is unlimited set limit as Infinity
		let couponCodeLim = 0;
		if (!accessCodeTicket && couponDetails)
			couponCodeLim = couponDetails.remaining ? couponDetails.remaining : Infinity;
		else
			couponCodeLim = newTicketDetails[0].remaining
				? newTicketDetails[0].remaining
				: Infinity;

		if (notTeamBasedHiddenTicket && isTeamBasedHiddenTicket) {
			setTeamRegStatus(2);
		}

		setCouponCodeLimit(couponCodeLim); //
		setCouponInitialLimit(couponCodeLim); //
		setCouponCode(coupon);
		setTicketDetails(newTicketDetails);
		setIsNewCode(true);
		if (isWaitlist) setWaitlistDetails(newTicketDetails); //if waitlist payment , update waitlist details
	};

	const removeCoupon = (isAccessCode = false) => {
		if (!isAccessCode) {
			const newTicketDetails = [...ticketDetails];
			newTicketDetails.forEach(ticket => {
				ticket.final_price = ticket.ticket_price;
				ticket.discount = null;
				ticket.discount_remaining = null;
				ticket.discounted_price = null;
			});
			setTicketDetails(newTicketDetails);
		} else if (isAccessCode) {
			setCurComp(0);
			setTicketDetails("");
			setPickedTickets([]);
			setIsEventPageTeamComp(false);
			setTeamRegType(0);
			sessionStorage.removeItem("isEventPageTeamComp");
		}
		setCouponCode("");
		setCouponCodeLimit(null);
		setCouponInitialLimit(null);
	};

	// Function that needs to be called for free tickets - to add booking_id to attendee details
	const addBookingIdToAttendeesDetails = (leadsResponse, attendeesDetails) => {
		const newAttendeeDetails = { ...attendeesDetails };
		const bookingIds = leadsResponse.booking_ids;
		let indexNo = 0;
		Object.keys(attendeesDetails).map(ticketId => {
			attendeesDetails[ticketId].map((attendeeObj, i) => {
				newAttendeeDetails[ticketId][i] = {
					...attendeeObj,
					booking_id: bookingIds[indexNo]
				};
				indexNo++;
			});
		});
		setAttendeesDetails(newAttendeeDetails);
	};

	// Waitlist UseEffect -> refer to readMe.md
	useEffect(() => {
		// if approved or waitlist payment, go directly to attendeesDetails
		if (isWaitlist) {
			// const selectedTicket = ticketDetails.filter(ticket => {
			//   if (waitlistDetails.ticket_id === ticket.ticket_id) return true;
			//   else false;
			// })
			waitlistDetails[0].totalSelected = 1;
			const gstData = {};
			if (waitlistDetails[0].buyer_name) gstData.buyer_name = waitlistDetails[0].buyer_name;
			if (waitlistDetails[0].buyer_email)
				gstData.buyer_email = waitlistDetails[0].buyer_email;
			if (waitlistDetails[0].buyer_tax_no)
				gstData.buyer_tax_no = waitlistDetails[0].buyer_tax_no;
			if (waitlistDetails[0].buyer_business_name)
				gstData.buyer_business_name = waitlistDetails[0].buyer_business_name;
			if (waitlistDetails[0].buyer_business_address)
				gstData.buyer_business_address = waitlistDetails[0].buyer_business_address;

			setPickedTickets([waitlistDetails[0]]);
			setGstDetails({ ...gstData });

			const visibility = {
				[`${waitlistDetails[0].ticket_id}-0`]: {}
			};
			waitlistDetails[0].forms.map(
				form =>
				(visibility[`${waitlistDetails[0].ticket_id}-0`][form.form_id] =
					typeof form.form_visibility === "boolean" ? form.form_visibility : true)
			);
			setFormikValue({
				...gstData,
				[`${waitlistDetails[0].ticket_id}-0`]: convertToFormikValues(waitlistDetails[0]),
				visibility
			});
			setCurComp(1);
		}
	}, [waitlistDetails, ticketDetails]);

	// Coupon UseEffect -> refer to readMe.md -> Adding coupon code after first screen
	useEffect(() => {
		// This is run when adding a new coupon code or moving to a new screen.
		if (curComp > 0 && couponCodeLimit && isNewCode) {
			let discountTickets = 0;
			let isCouponApplicable = false;
			let isWaitlistRequest = false;
			let isApprovalRequest = false;
			const allTickets = filterObjectsById(pickedTickets, ticketDetails);
			if (allTickets.length > 0) {
				setPickedTickets(allTickets); // temporary
			}
			allTickets.forEach(ticket => {
				if (ticket.waitlist_enabled && ticket.sold_out && !query.booking_id) {
					isWaitlistRequest = true;
					return;
				} else if (ticket.approval_enabled) {
					isApprovalRequest = true;
					return;
				} else {
					if (ticket?.discount) {
						discountTickets = discountTickets + ticket.totalSelected;
						if (ticket.coupon_applicable) isCouponApplicable = true;
					}
				}
			});
			if (couponCodeLimit - discountTickets < 0) {
				setCouponErr(
					`You have selected more tickets than the coupon code remaining, to apply coupon code please remove ${-(
						couponCodeLimit - discountTickets
					)} coupon applicable tickets`
				);
			} else if (
				isCouponApplicable ||
				(isWaitlistRequest && accessCodeStatus === 1) ||
				(isApprovalRequest && accessCodeStatus === 1)
			) {
				setCouponCodeLimit(couponCodeLimit - discountTickets);
				setIsNewCode(false);
			} else if (isWaitlistRequest && !(accessCodeStatus === 1)) {
				// if its waitlist and is coupon code applied (not access code)
				setCouponErr(
					`You cannot apply a coupon while requesting for a waitlist, please apply after your waitlist has been approved`
				);
			} else if (isApprovalRequest && !(accessCodeStatus === 1)) {
				// if its approval and is coupon code applied (not access code)
				setCouponErr(
					`You cannot apply a coupon while registering your interest, please apply after your registration has been approved`
				);
			}
			// else {
			// 	if(!query.booking_id && !query.ticketId && !query.ticket_id && !query.teamRegType){
			// 		// execute only if there is no `booking_id=`, `ticketId=`, `ticket_id`, `teamRegType` in the query
			// 		setCouponErr(
			// 			`You cannot apply this coupon to any of the tickets you have selected.`
			// 		);
			// 	}
			// }
		}
	}, [couponCodeLimit, curComp]);

	// FormikValue useEffect -> refer to readMe.md
	useEffect(() => {
		if (curComp === 0 && !_.isEmpty(formikValues)) {
			setFormikValue([]);
		}
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	}, [curComp]);

	useEffect(() => {
		//This is to recall the tickets after access code is removed
		if (accessCodeStatus === 2) {
			getTicketDetails(query.eventUrl, false, query.referred_by ? true : false);
			setAccessCodeStatus(0); // Change status to 0 which is "no access code applied"
		}
	}, [accessCodeStatus]);

	const component =
		curComp === 0 ? (
			<PickTickets
				ticketDetails={ticketDetails}
				couponCodeLimit={couponCodeLimit}
				query={query}
				isLoading={isLoading}
				onTicketSelect={onTicketSelect}
				onProceed={onProceed}
				eventDetails={eventDetails}
				isWidget={isWidget}
				pickedTickets={pickedTickets}
				initialMount={initialMount}
				accessCodeStatus={accessCodeStatus}
				triggeredOnce={triggeredOnce}
				accessCodeTriggered={accessCodeTriggered}
				teamRegType={teamRegType}
				couponLoading={couponLoading}
				groupDiscounts={groupDiscounts}
				setInitialMount={setInitialMount}
			/>
		) : curComp === 1 ? (
			<AttendeeDetails
				ticketDetails={ticketDetails}
				eventDetails={eventDetails}
				selectedTickets={pickedTickets}
				onCheckout={onCheckout}
				query={query}
				isWidget={isWidget}
				formikValues={formikValues}
				isBackClicked={isBackClicked}
				setIsBackClicked={setIsBackClicked}
				onBackBtn={() => setCurComp(0)}
				isCheckoutSubmitted={isCheckoutSubmitted}
				setIsCheckoutSubmitted={setIsCheckoutSubmitted}
				profileData={profileData}
				setProfileData={setProfileData}
				emailApiErrors={emailApiErrors}
				setEmailApiErrors={setEmailApiErrors}
				setTextInputErrors={setTextInputErrors}
				textInputErrors={textInputErrors}
				textInputErrorMsg={textInputErrorMsg}
				setTextInputErrorMsg={setTextInputErrorMsg}
				GSTDetails={gstDetails}
				setGstDetails={setGstDetails}
				isValidating={isValidating}
				setIsValidating={setIsValidating}
				formRules={formRules}
			/>
		) : curComp === 2 ? (
			<ReviewTickets
				eventDetails={eventDetails}
				selectedTickets={pickedTickets}
				attendeesDetails={attendeesDetails}
				reviewDetails={reviewDetails}
				query={query}
				isWidget={isWidget}
				isInternationalEvent={isInternationalEvent}
				isWaitlist={isWaitlist}
				orderAmount={orderAmount}
				textInputErrors={textInputErrors}
			/>
		) : curComp === 3 ? (
			<TeamBasedComponent
				color={query.btnBg ? `#${query.btnBg}` : "#fb5850"}
				teamRegStatus={teamRegStatus}
				setTeamRegType={setTeamRegType}
				eventData={eventDetails}
				query={query}
				onJoinTeam={team => {
					sessionStorage.setItem("team_name", team.team_name);
					sessionStorage.setItem("team_id", team.team_id);
					sessionStorage.setItem("team_attendee_count", team.team_attendee_count);
					setTeamRegType(2);
					setCurComp(0);
				}}
				onCreateTeam={val => {
					sessionStorage.setItem("team_name", val.team_name);
					sessionStorage.setItem("team_lead_name", val.team_lead_name);
					sessionStorage.setItem("team_lead_email", val.team_lead_email);
					setTeamRegType(1);
					setCurComp(0);
				}}
				onIndividual={() => {
					setTeamRegType(0);
					setCurComp(0);
				}}
			/>
		) : null;

	if (query.tap_id)
		return (
			<Modal
				isOpen={true}
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
				style={modalStyles}
			>
				<Loading />
			</Modal>
		);

	return (
		<div>
			{!isWidget && faviconIconUrl ? (
				<Head>
					<link rel="icon" href={faviconIconUrl} />
				</Head>
			) : (
				<Head>
					<link rel="icon" href="./favicon/globe.ico" />
				</Head>
			)}
			<div className="checkout-container">
				<div className="d-block d-lg-flex container-height pb-3">
					<PaymentErrorModal
						isOpen={openErrModal}
						closeModal={() => setOpenErrModal(false)}
						errorType={modalErrType}
						onClickBtn={() => Router.reload(`${baseUrl}${router.asPath}`)}
					/>

					<div className={"reg-header-con d-md-block d-lg-flex"}>
						<RegistrationHeader
							curComp={curComp}
							query={query}
							isWidget={isWidget}
							isLoading={isLoading}
							eventDetails={eventDetails}
							handleBackBtn={handleBackBtn}
							ticketDetails={ticketDetails}
						/>
					</div>
					<WidgetContext.Provider
						value={{
							isWidget,
							couponCode,
							eventDetails,
							query,
							otp,
							setOtp,
							isWaitlist,
							waitlistDetails,
							setAccessCodeStatus,
							setTicketDetails,
							curComp,
							setCurComp,
							accessCodeStatus,
							setPickedTickets,
							setOrderAmount,
							setUtm,
							isCheckoutLoading,
							groupDiscounts,
							leadsResponse,
							isApproval,
							setOpenErrModal,
							setModalErrType,
							isInternationalEvent,
							isInternationalTicket,
							setPaymentMethod,
							paymentMethod,
							setOpenPaymentModal,
							teamRegType,
							setCouponLoading,
							couponLoading,
							totalActiveRegs
						}}
					>
						<div className={"reg-container d-block w-md-100 pt-4 pt-md-0 d-md-flex"}>
							<div className="w-md-100 me-md-2 ms-md-0 reg-body-con border-box">
								{curComp !== 0 && curComp !== 3 && (
									<RegistrationTimer
										openPaymentModal={openPaymentModal}
										url={`${baseUrl}${router.asPath}`}
										query={query}
										selectedTickets={pickedTickets}
										eventDetails={eventDetails}
										className="d-flex justify-content-center align-items-center timer-count d-md-none mx-auto"
									/>
								)}
								{component}
							</div>

							{!smallerScreen && (
								<CartBox
									reviewDetails={reviewDetails}
									selectedTickets={pickedTickets}
									attendeesDetails={attendeesDetails}
									ticketDetails={ticketDetails}
									eventDetails={eventDetails}
									query={query}
									isMobile={false}
									getCouponDetails={getCouponDetails}
									removeCoupon={removeCoupon}
									couponErr={couponErr}
									setCouponErr={setCouponErr}
									onProceed={onProceed}
									curComp={curComp}
									isWidget={isWidget}
									groupDiscounts={groupDiscounts}
									setIsCheckoutSubmitted={setIsCheckoutSubmitted}
									emailApiErrors={emailApiErrors}
									utm={utm}
									waitlistDetails={waitlistDetails}
									textInputErrors={textInputErrors}
									GSTDetails={gstDetails}
									isValidating={isValidating}
									setFormRules={setFormRules}
									isEventPageTeamComp={isEventPageTeamComp}
								/>
							)}
							{smallerScreen && (
								<div style={{ marginBottom }} className="reg-footer-con">
									<CartBox
										reviewDetails={reviewDetails}
										selectedTickets={pickedTickets}
										attendeesDetails={attendeesDetails}
										ticketDetails={ticketDetails}
										eventDetails={eventDetails}
										query={query}
										isMobile={true}
										getCouponDetails={getCouponDetails}
										removeCoupon={removeCoupon}
										couponErr={couponErr}
										setCouponErr={setCouponErr}
										onProceed={onProceed}
										curComp={curComp}
										isWidget={isWidget}
										groupDiscounts={groupDiscounts}
										setIsCheckoutSubmitted={setIsCheckoutSubmitted}
										emailApiErrors={emailApiErrors}
										utm={utm}
										waitlistDetails={waitlistDetails}
										textInputErrors={textInputErrors}
										GSTDetails={gstDetails}
										isValidating={isValidating}
										setFormRules={setFormRules}
										isEventPageTeamComp={isEventPageTeamComp}
									/>
								</div>
							)}
						</div>
					</WidgetContext.Provider>
				</div>

				{eventDetails?.checkout_footer_icon && (
					<div className="d-flex image-main-box justify-content-center mb-6 text-center">
						<div className="d-md-block">
							<img
								className="image-container"
								src={eventDetails.checkout_footer_icon}
							/>
						</div>
					</div>
				)}
			</div>
			<style jsx global>{`
        .image-main-box{
          margin-bottom: 10px !important;
        }

        .image-container{
        height: 85px;
        width: auto;
        }

        .border-box {
		  overflow: hidden;
          border-top: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"};
          border-right: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"};
          border-bottom: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"};
		  border-left: ${curComp === 3 || _.isEmpty(ticketDetails)
					? `2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"}`
					: "none"
				};
          border-radius: ${curComp === 3 || _.isEmpty(ticketDetails)
					? "25px"
					: `0px ${query?.borderRadius || 10}px ${query?.borderRadius || 10}px 0px`
				};
        }
	

        .reg-container {
          position: relative;
        }
        .w-md-100 {
          width: 100%;
        }
        .container-bg {
          background: ${query.bg || query.primaryBg ? `#${query.bg || query.primaryBg}` : "#fff"};
          border-radius: ${query.borderRadius || 10}px;
        }
        @media (min-width: 992px) {
          .border-box {
            min-height: calc(100vh - 250px);
          }
        }
        @media (min-width: 768px) and (max-width: 991px) {
          .border-box {
            border-left: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#b79fb1"};
            border-radius: ${query?.borderRadius || 10}px;
          }
          .container-bg {p
            border-radius: ${query?.borderRadius || 10}px;
          }
          .reg-container {
            margin-top: 10px !important;
          }
        }
        @media (max-width: 768px) {
          .checkout-container{
            display: flex;
            flex-direction:column;

          }
          .reg-header-con {
            position: sticky;
            left: 0;
            right: 0;
            top: 0;
            z-index: 100;
            box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.2);
          }
          .reg-footer-con {
            margin: 0px 10px;

          }
          .reg-container {
            border-radius: 0px;
            width: 100vw !important;
            margin-left: calc(-50vw + 50%);
            padding-top: 0px !important;
            margin-bottom: 0rem;
          }
          .container-bg {
            border-radius: 0px 0px 0px 0px;
          }
          .w-md-100 {
            width: auto;
          }
          .reg-container {
            background: ${query.primaryBg ? `#${query.primaryBg}` : "#fff"};
          }
        }

        @media (max-width: 768px) {
          .border-box {
            border: none;
          }
        }

        @media (max-height: 500px) {
          .reg-container {
            height: auto;
          }
        }
		@media (max-width: 767px){
			.image-main-box{
          margin-bottom: 100px !important;
        } 
		}
        `}</style>
		</div>
	);
};

export default RegistrationBox;
